export const BOOKING_STATUS_COLOR_MAP: Record<
  string,
  'success' | 'danger' | 'warning' | 'secondary' | 'primary'
> = {
  Completed: 'success',
  Pending: 'warning',
  Confirmed: 'primary',
  InProgress: 'secondary',
  Waiting: 'warning',
  Cancelled: 'danger',
};

export const CURRENCY = {
  code: 'CAD',
  locale: 'en-CA',
  label: 'Canadian Dollar',
};

//PROVINCES AND TERRITORIES
export const canadaProvincesAndTerritories = [
  { label: 'Alberta', key: 'Alberta' },
  { label: 'British Columbia', key: 'British Columbia' },
  { label: 'Manitoba', key: 'Manitoba' },
  { label: 'New Brunswick', key: 'New Brunswick' },
  { label: 'Nova Scotia', key: 'Nova Scotia' },
  { label: 'Newfoundland and Labrador', key: 'Newfoundland and Labrador' },
  { label: 'Prince Edward Island', key: 'Prince Edward Island' },
  { label: 'Ontario', key: 'Ontario' },
  { label: 'Quebec', key: 'Quebec' },
  { label: 'Saskatchewan', key: 'Saskatchewan' },

  // Territories
  { label: 'Northwest Territories', key: 'Northwest Territories' },
  { label: 'Yukon', key: 'Yukon' },
  { label: 'Nunavut', key: 'Nunavut' },
];

export const CANADA_PROVINCES_OBJECT = Object.freeze({
  ontario: 'ontario',
  quebec: 'quebec',
  nova: 'nova scotia',
  new_brunswick: 'new brunswick',
  manitoba: 'manitoba',
  british_columbia: 'british columbia',
  prince_edward_island: 'prince edward island',
  saskatchewan: 'saskatchewan',
  alberta: 'alberta',
  newfoundland_and_labrador: 'newfoundland and labrador',
  northwest_territories: 'northwest territories',
  yukon: 'yukon',
  nunavut: 'nunavut',
});

export const canadaProvincesAndTerritoriesArray = [
  'ontario',
  'quebec',
  'nova scotia',
  'new brunswick',
  'manitoba',
  'british columbia',
  'prince edward island',
  'saskatchewan',
  'alberta',
  'newfoundland and labrador',
  'northwest territories',
  'yukon',
  'nunavut ',
];

//COUNTRY
export const countryData = [{ label: 'Canada', key: 'Canada' }];

export const countryArry = ['canada'];

export const languageData = [{ label: 'English', id: 'English' }];

export const languageArray = ['English'];

export const currencyCodeData = [{ label: 'CAD', id: 'CAD' }];

export const businessCategoryData = [
  { label: 'Renovation & Remodeling', id: 'renovation-remodeling' },
  { label: 'Plumbing', id: 'plumbing' },
  { label: 'Electrical', id: 'electrical' },
  { label: 'HVAC (Heating & Cooling)', id: 'hvac-heating-cooling' },
  { label: 'Roofing', id: 'roofing' },
  { label: 'Landscaping & Lawn Care', id: 'landscaping-lawn-care' },
  { label: 'Snow Removal', id: 'snow-removal' },
  { label: 'Residential Cleaning', id: 'residential-cleaning' },
  { label: 'Pest Control', id: 'pest-control' },
  { label: 'Handyman Services', id: 'handyman-services' },
  { label: 'Painting', id: 'painting' },
  { label: 'Flooring Installation', id: 'flooring-installation' },
  { label: 'Appliance Repair', id: 'appliance-repair' },
  {
    label: 'Window & Door Installation',
    id: 'window-door-installation',
  },
  { label: 'Junk Removal', id: 'junk-removal' },
  { label: 'Property Management', id: 'property-management' },

  { label: 'Auto Repair & Mechanics', id: 'auto-repair-mechanics' },
  { label: 'Auto Detailing', id: 'auto-detailing' },
  { label: 'Tire Services', id: 'tire-services' },
  { label: 'Car Wash', id: 'car-wash' },
  { label: 'Auto Body Repair', id: 'auto-body-repair' },
  { label: 'Mobile Mechanics', id: 'mobile-mechanics' },
  { label: 'Towing Services', id: 'towing-services' },
  { label: 'Car Dealerships', id: 'car-dealerships' },
  { label: 'Vehicle Inspections', id: 'vehicle-inspections' },

  { label: 'Hair Salons & Barbers', id: 'hair-salons-barbers' },
  { label: 'Estheticians & Skincare', id: 'estheticians-skincare' },
  { label: 'Nail Salons', id: 'nail-salons' },
  { label: 'Massage Therapy', id: 'massage-therapy' },
  { label: 'Physiotherapy', id: 'physiotherapy' },
  { label: 'Chiropractors', id: 'chiropractors' },
  { label: 'Personal Trainers', id: 'personal-trainers' },
  { label: 'Yoga & Pilates Studios', id: 'yoga-pilates-studios' },
  { label: 'Nutritionists', id: 'nutritionists' },
  {
    label: 'Mental Health Counselling',
    id: 'mental-health-counselling',
  },
  {
    label: 'Tattoo & Piercing Studios',
    id: 'tattoo-piercing-studios',
  },

  { label: 'Real Estate Agents', id: 'real-estate-agents' },
  { label: 'Mortgage Brokers', id: 'mortgage-brokers' },
  { label: 'Home Inspectors', id: 'home-inspectors' },
  { label: 'Appraisers', id: 'appraisers' },
  { label: 'Movers', id: 'movers' },
  { label: 'Storage Services', id: 'storage-services' },
  { label: 'Home Staging', id: 'home-staging' },

  { label: 'Tutors', id: 'tutors' },
  { label: 'Driving Schools', id: 'driving-schools' },
  { label: 'Music Teachers', id: 'music-teachers' },
  { label: 'Language Schools', id: 'language-schools' },
  { label: 'Business Coaching', id: 'business-coaching' },
  { label: 'Trade Schools', id: 'trade-schools' },

  { label: 'Childcare Services', id: 'childcare-services' },
  { label: 'Daycares', id: 'daycares' },

  { label: 'Accountants & Bookkeepers', id: 'accountants-bookkeepers' },
  { label: 'Tax Services', id: 'tax-services' },
  { label: 'Lawyers', id: 'lawyers' },
  { label: 'Notaries', id: 'notaries' },
  { label: 'Insurance Brokers', id: 'insurance-brokers' },
  { label: 'Financial Advisors', id: 'financial-advisors' },
  { label: 'Marketing Agencies', id: 'marketing-agencies' },
  {
    label: 'Web Designers & Developers',
    id: 'web-designers-developers',
  },
  { label: 'IT Support Services', id: 'it-support-services' },
  { label: 'HR Consultants', id: 'hr-consultants' },

  { label: 'Licensed Security Guard', id: 'licensed-security-guard' },
  { label: 'Private Investigator', id: 'private-investigator' },
  { label: 'CCTV Installation', id: 'cctv-installation' },
  { label: 'Fire Safety Inspection', id: 'fire-safety-inspection' },
  {
    label: 'Alarm System Installation',
    id: 'alarm-system-installation',
  },
  {
    label: 'Safety Compliance Audit',
    id: 'safety-compliance-audit',
  },
  { label: 'Security Services', id: 'security-services' },

  { label: 'Restaurants', id: 'restaurants' },
  { label: 'Catering Services', id: 'catering-services' },
  { label: 'Bakeries', id: 'bakeries' },
  { label: 'Coffee Shops', id: 'coffee-shops' },
  { label: 'Food Trucks', id: 'food-trucks' },
  { label: 'Meal Prep Services', id: 'meal-prep-services' },

  { label: 'Event Venues', id: 'event-venues' },
  { label: 'Event Planners', id: 'event-planners' },
  { label: 'DJs', id: 'djs' },
  { label: 'Photographers', id: 'photographers' },
  { label: 'Videographers', id: 'videographers' },
  { label: 'Wedding Services', id: 'wedding-services' },
  { label: 'Party Rentals', id: 'party-rentals' },
  { label: 'Musicians', id: 'musicians' },
  { label: 'Performers', id: 'performers' },

  { label: 'Veterinarians', id: 'veterinarians' },
  { label: 'Pet Grooming', id: 'pet-grooming' },
  { label: 'Pet Boarding', id: 'pet-boarding' },
  { label: 'Dog Walking', id: 'dog-walking' },
  { label: 'Pet Training', id: 'pet-training' },

  { label: 'Clothing Stores', id: 'clothing-stores' },
  { label: 'Gift Shops', id: 'gift-shops' },
  { label: 'Electronics Stores', id: 'electronics-stores' },
  { label: 'Furniture Stores', id: 'furniture-stores' },
  { label: 'Local Artisans', id: 'local-artisans' },
  { label: 'Convenience Stores', id: 'convenience-stores' },

  { label: 'Commercial Cleaning', id: 'commercial-cleaning' },
  { label: 'Commercial HVAC', id: 'commercial-hvac' },
  { label: 'Office Supplies', id: 'office-supplies' },
  { label: 'Signage & Printing', id: 'signage-printing' },
  { label: 'Waste Management', id: 'waste-management' },

  {
    label: 'Indigenous-Owned Businesses',
    id: 'indigenous-owned-businesses',
  },
  { label: 'Eco-Friendly Services', id: 'eco-friendly-services' },
  { label: 'Mobile Services', id: 'mobile-services' },
  { label: 'Senior Care Services', id: 'senior-care-services' },
  { label: 'Accessibility Services', id: 'accessibility-services' },

  { label: 'Other', id: 'other' },
];

export const currencyArray = ['CAD'];

export const individualDocumentType = [
  { label: 'Driving License', key: 'Driving License' },
  // { label: "Passport", key: "Passport" },
];

export const individualDocumentTypeArry = ['Driving License', 'Passport'];

export const organizationDocumentType = [
  // { label: "Driving License", key: "Driving License" },
  { label: 'Business Registration ', key: 'Business Registration' },
  // { label: "Passport", key: "Passport" },
];

export const organizationDocumentTypeArry = [
  'Business Registration',
  'Driving License',
  'Passport',
];

export const timeZoneData = [
  { label: 'America/Vancouver', id: 'America/Vancouver' },
  { label: 'America/Edmonton', id: 'America/Edmonton' },
  { label: 'America/Winnipeg', id: 'America/Winnipeg' },
  { label: 'America/Toronto', id: 'America/Toronto' },
  { label: 'America/Halifax', id: 'America/Halifax' },
  { label: 'America/St_Johns', id: 'America/St_Johns' },
];

export const documentUploadStatus = {
  NOT_UPLOADED: 'not-uploaded',
  SYSTEM_REVIEW_PENDING: 'system-review-pending',
  MANUAL_REVIEW_PENDING: 'manual-review-pending',
  SYSTEM_REVIEW_FAILED: 'system-review-failed',
  MANUAL_REVIEW_FAILED: 'manual-review-failed',
  VERIFIED: 'verified',
  NOT_VERIFIED: 'not-verified',
} as const;

export const CANADIAN_AREA_CODES = [
  '204',
  '226',
  '236',
  '249',
  '250',
  '263',
  '289',
  '306',
  '343',
  '354',
  '365',
  '368',
  '382',
  '387',
  '403',
  '416',
  '418',
  '431',
  '437',
  '438',
  '450',
  '468',
  '474',
  '506',
  '514',
  '519',
  '548',
  '579',
  '581',
  '584',
  '587',
  '604',
  '613',
  '639',
  '647',
  '672',
  '705',
  '709',
  '742',
  '778',
  '780',
  '807',
  '819',
  '825',
  '867',
  '873',
  '902',
  '905',
  '942',
];

export const US_AREA_CODES = [
  // Alabama
  '205',
  '251',
  '256',
  '334',
  '659',
  '938',
  // Alaska
  '907',
  // Arizona
  '480',
  '520',
  '602',
  '623',
  '928',
  // Arkansas
  '327',
  '479',
  '501',
  '870',
  // California
  '209',
  '213',
  '279',
  '310',
  '323',
  '341',
  '350',
  '369',
  '408',
  '415',
  '424',
  '442',
  '510',
  '530',
  '559',
  '562',
  '619',
  '626',
  '628',
  '650',
  '657',
  '661',
  '669',
  '707',
  '714',
  '747',
  '760',
  '805',
  '818',
  '820',
  '831',
  '840',
  '858',
  '909',
  '916',
  '925',
  '949',
  '951',
  // Colorado
  '303',
  '719',
  '720',
  '970',
  '983',
  // Connecticut
  '203',
  '475',
  '860',
  '959',
  // Delaware
  '302',
  // District of Columbia (Washington DC)
  '202',
  '771',
  // Florida
  '239',
  '305',
  '321',
  '352',
  '386',
  '407',
  '561',
  '656',
  '727',
  '754',
  '772',
  '786',
  '813',
  '850',
  '863',
  '904',
  '941',
  '954',
  // Georgia
  '229',
  '404',
  '470',
  '478',
  '678',
  '706',
  '762',
  '770',
  '912',
  '943',
  // Hawaii
  '808',
  // Idaho
  '208',
  '986',
  // Illinois
  '217',
  '224',
  '309',
  '312',
  '331',
  '447',
  '464',
  '618',
  '630',
  '708',
  '773',
  '815',
  '847',
  '872',
  // Indiana
  '219',
  '260',
  '317',
  '463',
  '574',
  '765',
  '812',
  '930',
  // Iowa
  '319',
  '515',
  '563',
  '641',
  '712',
  // Kansas
  '316',
  '620',
  '785',
  '913',
  // Kentucky
  '270',
  '364',
  '502',
  '606',
  '859',
  // Louisiana
  '225',
  '318',
  '337',
  '504',
  '985',
  // Maine
  '207',
  // Maryland
  '240',
  '301',
  '410',
  '443',
  '667',
  // Massachusetts
  '339',
  '413',
  '508',
  '617',
  '774',
  '781',
  '857',
  '978',
  // Michigan
  '231',
  '248',
  '269',
  '313',
  '517',
  '586',
  '616',
  '734',
  '810',
  '906',
  '947',
  '989',
  // Minnesota
  '218',
  '320',
  '507',
  '612',
  '651',
  '763',
  '952',
  // Mississippi
  '228',
  '601',
  '662',
  '769',
  // Missouri
  '314',
  '417',
  '557',
  '573',
  '636',
  '660',
  '816',
  '975',
  // Montana
  '406',
  // Nebraska
  '308',
  '402',
  '531',
  // Nevada
  '702',
  '725',
  '775',
  // New Hampshire
  '603',
  // New Jersey
  '201',
  '551',
  '609',
  '640',
  '732',
  '848',
  '856',
  '862',
  '908',
  '973',
  // New Mexico
  '505',
  '575',
  // New York
  '212',
  '315',
  '332',
  '347',
  '516',
  '518',
  '585',
  '607',
  '631',
  '646',
  '680',
  '716',
  '718',
  '838',
  '845',
  '914',
  '917',
  '929',
  '934',
  // North Carolina
  '252',
  '336',
  '704',
  '743',
  '828',
  '910',
  '919',
  '980',
  '984',
  // North Dakota
  '701',
  // Ohio
  '216',
  '220',
  '234',
  '326',
  '330',
  '419',
  '440',
  '513',
  '567',
  '614',
  '740',
  '937',
  // Oklahoma
  '405',
  '539',
  '580',
  '918',
  // Oregon
  '458',
  '503',
  '541',
  '971',
  // Pennsylvania
  '215',
  '223',
  '267',
  '272',
  '412',
  '484',
  '570',
  '610',
  '717',
  '724',
  '814',
  '878',
  // Rhode Island
  '401',
  // South Carolina
  '803',
  '839',
  '843',
  '854',
  '864',
  // South Dakota
  '605',
  // Tennessee
  '423',
  '615',
  '629',
  '731',
  '865',
  '901',
  '931',
  // Texas
  '210',
  '214',
  '254',
  '281',
  '325',
  '346',
  '361',
  '409',
  '430',
  '432',
  '469',
  '512',
  '682',
  '713',
  '726',
  '737',
  '806',
  '817',
  '830',
  '832',
  '903',
  '915',
  '936',
  '940',
  '956',
  '972',
  '979',
  // Utah
  '385',
  '435',
  '801',
  // Vermont
  '802',
  // Virginia
  '276',
  '434',
  '540',
  '571',
  '703',
  '757',
  '804',
  '948',
  // Washington
  '206',
  '253',
  '360',
  '425',
  '509',
  '564',
  // West Virginia
  '304',
  '681',
  // Wisconsin
  '262',
  '414',
  '534',
  '608',
  '715',
  '920',
  // Wyoming
  '307',
];

export const NORTH_AMERICAN_AREA_CODES = [
  ...CANADIAN_AREA_CODES,
  ...US_AREA_CODES,
];

export const ACCOUNT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DEACTIVATED: 'deactivated',
  SUSPENDED: 'suspended',
  PENDING_DELETE: 'pending_deletion',
  DELETED: 'deleted',
};

export const ERROR_CODE = {
  INVALID_PORTAL_ACCESS: 'invalid_portal_access',
  SELF_SIGNUP_NOT_ALLOWED: 'self_signup_not_allowed',
  USER_NOT_CREATE_ERROR: 'user_not_create_error',
  INVALID_TOKEN: 'invalid_token',
  UNAUTHRIZED: 'unauthorized',
  RESOURCE_NO_LONGER_AVAILABLE: 'resource_no_longer_available',
  DEFAULT: 'default',
};

export const COMPANY_DETAILD = {
  NAME: 'HirePanther',
  DESCRIPTION:
    'HirePanther is a Canadian marketplace that connects customers with independent local service providers.',
  ADDRESS: {
    COUNTRY: 'CA',
    STREET: 'Suite 100, 6750 4th Avenue SW',
    CITY: 'Calgary',
    STATE: 'Alberta',
    POSTAL_CODE: 'T2H 2H7',
  },
  LOGO: '../assets/logo/Copy of Hire-Panther_B-01.png',
};
